var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-no-ssr',{staticClass:"layout"},[_c('Header'),_c('router-view',{staticClass:"layout-view"}),_c('CallWaiter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }